<template>
    <v-row
        v-if="showReminder"
        class="borderFluCovid"
        data-testid="show-reminder"
    >
        <v-col cols="10" md="11" class="pa-6 body-1" v-html="$t('coAdministrationFluCovid.couponReminder')" />
        <v-col cols="2" md="1" class="pa-0">
            <v-img
                class="float-right"
                :src="`https://static.trimoz.com/clicsante/images/${setCovidFluChipLocale}`"
                max-height="94"
                max-width="94"
            />
        </v-col>
    </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import { get, includes } from 'lodash';
import { CoAdministrationServiceTemplateIds } from '@/enums';

export default {
    name: 'coupon-co-administration-reminder',
    props: {
        service: { type: Object, required: true },
        appointment: { type: Object, required: true },
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
        }),
        showReminder() {
            return includes(
                [CoAdministrationServiceTemplateIds.FLU, CoAdministrationServiceTemplateIds.COVID],
                get(this.service, 'serviceTemplate.id', 0)
            ) && this.appointment.clientData.isOtherServiceWanted;
        },
        setCovidFluChipLocale() {
            return 'pastille-grippe-covid-' + this.locale + '.png';
        },
    },
};
</script>
<style lang="scss" scoped>
.borderFluCovid::v-deep {
    border: 4px solid #FCC987!important;
    border-radius: 4px;
    background-color: #FFFFFF;
}
</style>
